export default "__VITE_ASSET__CKnUl4es__"